export default (element, type = 'change', interfaceName = 'HTMLEvents') => {
  const evt = document.createEvent(interfaceName);
  evt.initEvent(type, false, true);
  element.dispatchEvent(evt);
};
